import React from "react";
import { Select } from "antd";
import { NavLink, Link } from "react-router-dom";
import menuIcon from "../../assets/menu.png";
import closeIcon from "../../assets/close.png";
import logo from "../../assets/logo.png";
import { navigation } from "../../intl";

const Option = Select.Option;

export const links = [
  { key: 0, value: "/", title: navigation.home },
  { key: 1, value: "/our-tools", title: navigation.ourTools },
  { key: 2, value: "/methodology", title: navigation.methodology },
  { key: 3, value: "/services", title: navigation.services },
  { key: 4, value: "/blog", title: navigation.blog },
  { key: 5, value: "/about-us", title: navigation.about },
  { key: 6, value: "/contact", title: navigation.contact }
];

class HeaderNavigation extends React.Component {
  constructor() {
    super();
    this.state = {
      isOpen: false
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange({ key, value }) {
    this.props.changeLanguage(key);
  }

  render() {
    const mobileClass = this.state.isOpen
      ? "narrowLinks"
      : "narrowLinks hidden";
    const menu = links.map(link => (
      <NavLink key={link.key} to={link.value} exact activeClassName="activeNav">
        {link.title[this.props.language]}
      </NavLink>
    ));
    return (
      <nav>
        <div className="logo">
          <Link to={"/"}>
            <img alt='header-nav' src={logo} height="70px" />
          </Link>
        </div>
        <div className="navWide">
          <div className="wideDiv">
            {menu}
            {/* <a href="mailto:info@leadershipdynamic.net">
              {intl.mailto[this.props.language]}
            </a> */}
            <div className="navBorder" />
          </div>
        </div>
        <div className="navNarrow">
          <div
            style={{ minHeight: "35px" }}
            onClick={() => this.setState({ isOpen: !this.state.isOpen })}
          >
            {this.state.isOpen ? (
              <img
                alt='header-nav'
                style={{
                  width: "20px",
                  position: "absolute",
                  right: "13px",
                  top: "8px",
                  filter: "invert(1)"
                }}
                src={closeIcon}
              />
            ) : (
              <img
              alt='header-nav'
              style={{
                  width: "25px",
                  position: "absolute",
                  right: "10px",
                  top: "5px",
                  filter: "invert(1)"
                }}
                src={menuIcon}
              />
            )}
          </div>
          <div className={mobileClass}>{menu}</div>
        </div>
        <div className="header_navigation_language">
          <Select
            labelInValue
            defaultValue={{ key: this.props.language }}
            value={{ key: this.props.language }}
            style={{ width: 120 }}
            onChange={this.handleChange}
          >
            <Option value="dk">Dansk</Option>
            <Option value="en">English</Option>
          </Select>
        </div>
      </nav>
    );
  }
}

export default HeaderNavigation;



// WEBPACK FOOTER //
// ./src/components/HeaderNavigation/index.js